import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getUserID } from "../../../../services/user.service";
import { setPlanPermission, setUserDetail } from "./userSlice";
import http from "../../../../services/http.service";

const API_URL = process.env.REACT_APP_API_URL;

const GET_USER = `${API_URL}/users/`;
const GET_USER_PROFILE = `/manage-profile`;
const GET_CPA_CLIENT_LIST = `/cpa/client/list`;


export const getUser = createAsyncThunk(
  "getUser",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const userId = getUserID();
      const { data } = await axios.get(`${GET_USER}${userId}`);
      dispatch(setUserDetail(data))
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getUserProfile = createAsyncThunk(
  "getUserProfile",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(GET_USER_PROFILE);
      dispatch(setUserDetail(response?.data?.data))
      dispatch(setPlanPermission(response?.data?.data?.plan_permissions))
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

//  cpa client list
export const getCpaClientList = createAsyncThunk(
  "getCpaClientList",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(GET_CPA_CLIENT_LIST);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);